import http from "@/utils/request";

const taxRechargeOrderApi = {
  pageQuery: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxRecharge.pageQuery",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  add: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxRecharge.add",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  edit: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxRecharge.edit",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  audit: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxRecharge.audit",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  listOperateLog: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxRecharge.listOperateLog",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  submitTaxRechargeBuildExcelTask: (data) =>
    http.sendRequest({
      METHOD_NAME: "taxRecharge.submitTaxRechargeBuildExcelTask",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default taxRechargeOrderApi;
